import React from 'react'
import ReactDOM from 'react-dom'
import createMuiTheme from 'material-ui/styles/theme'
import createPalette from 'material-ui/styles/palette'
import amber from 'material-ui/colors/amber'
import green from 'material-ui/colors/green'
import orange from 'material-ui/colors/orange'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import DrawerMenu from './drawermenu'


const theme = createMuiTheme({
    palette: createPalette({
        primary: green,
        accent: {
            ...amber,
            A400: '#1a5e40',
        },
        error: orange,
    })
});


const App = () => (
    <MuiThemeProvider theme={theme}>
        <DrawerMenu/>
    </MuiThemeProvider>
);

ReactDOM.render(
    <App/>,
    document.getElementById('root')
);


export default App;


// WEBPACK FOOTER //
// ./src/App.js